import { Box, styled, Typography } from '@mui/material';

export const ContainerLeftStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'Column',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  fontSize: '12px',
  fontWeight: 900,
  height: 'auto',
  marginLeft: '16px',
  marginRight: 'auto',
}));

export const LabelHeaderStyled = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 'bold',
  color: theme.palette.colors.mainFocused,
  marginTop: '16px',
  marginLeft: '16px',
  textTransform: 'Uppercase',
  height: 16,
}));

export const LabelStyled = styled(Typography)(({ theme }) => ({
  fontWeight: '500',
  color: theme.palette.colors.lower,
  marginTop: '16px',
  textTransform: 'Uppercase',
  [theme.breakpoints.up('xxl')]: {
    fontSize: '12px',
  },
  [theme.breakpoints.between('lg', 'xxl')]: {
    fontSize: '10px',
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: '10px',
  },
}));

export const LabelValueStyled = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 500,
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));

export const BoxStyled = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.colors.borderLine}`,
  borderRadius: '5px',
  backgroundColor: theme.palette.colors.secondaryBackground,
  display: 'flex',
  [theme.breakpoints.up('xxl')]: {
    margin: '4px 31px 0 0',
    width: 315,
    height: '100%',
  },
  [theme.breakpoints.between('lg', 'xxl')]: {
    margin: '4px 0 0 0',
    width: 267,
    height: '100%',
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    margin: '4px 0 0 0',
    width: 218,
    minHeight: 293,
    paddingBottom: '16px',
  },
  [theme.breakpoints.down('sm')]: {
    margin: '4px 0 0 0',
    width: 312,
    minHeight: 282,
    paddingBottom: '16px',
  },
}));

export const BoxIssuanceDividerStyled = styled(Box)(({ theme }) => ({
  borderRight: `1px solid ${theme.palette.colors.borderLine}`,
  height: '200px',
  marginTop: '50px',
}));

export const BoxIssuanceStyled = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: 'inherit',
}));

export const BoxClientStyled = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: 'inherit',
}));
